export default __webpack_public_path__ + "static/ahmad-5c0a8aabb084f5e6468210067820bcce.jpg";